import React, {Component} from 'react';
import {ResponsiveLine} from "@nivo/line";
import {Typography, Checkbox, FormControlLabel, FormControl, InputLabel, Select, MenuItem, Input, ListItemText} from "@material-ui/core";
import moment from 'moment-timezone'

const MenuProps = {
    PaperProps: {
        style: {
            width: 250,
        },
    },
};

class CurveChart extends Component {
    constructor(props) {
        super(props);
        this.state = {
            logarithmic: false,
            provinces: []
        }
    }

    /* -------- LIFECYCLE METHODS -------- */

    /* -------- FUNCTIONS -------- */
    getDate = (date) => {
        let Y = date.substr(6)
        let M = date.substr(3, 2)
        let D = date.substr(0, 2)

        return Y+"-"+M+"-"+(parseInt(D)+1) //TODO fix EST UTC
    }

    getProvinceName = (id) => {
        switch (id) {
            case "CA":
                return "Canada"
            case "AB":
                return "Alberta"
            case "BC":
                return "British Colombia"
            case "ON":
                return "Ontario"
            case "QC":
                return "Quebec"
            case "SK":
                return "Saskatchewan"
            case "MB":
                return "Manitoba"
            case "NS":
                return "Nova Scotia"
            case "NB":
                return "New Brunswick"
            case "NL":
                return "Newfoundland and Labrador"
            case "PEI":
                return "Prince Edward Island"
            case "YT":
                return "Yukon"
            case "NT":
                return "Northwest Territories"
            case "NU":
                return "Nunavut"
            case "RT":
                return "Repatriated Traveller"
            default:
                return ""
        }
    }

    handleChangeMultiple = (event) => {
        this.setState({
            provinces: event.target.value
        });
    };

    /* -------- API CALLS -------- */


    /* -------- RENDERS -------- */
    renderValue = (values) => {
        if (values.length === 1) {
            return this.getProvinceName(values[0])
        } else if (values.length === 15) {
            return "All Selected"
        } else {
            return values.length + " Selected"
        }

    }

    renderProvinceSelect = () => {
        return <div style={{display: 'flex', justifyContent: 'flex-start', height: 72}}>
            <FormControl style={{minWidth: 120, maxWidth: 300}}>
                <InputLabel>Filter</InputLabel>
                <Select id="provinces-select"
                        multiple
                        value={this.state.provinces}
                        onChange={this.handleChangeMultiple}
                        renderValue={this.renderValue}
                        input={<Input />}
                        MenuProps={MenuProps}>
                    <MenuItem value="CA" >
                        <Checkbox checked={this.state.provinces.indexOf("CA") > -1} />
                        <ListItemText primary={this.getProvinceName("CA")} />
                    </MenuItem>
                    <MenuItem value="AB">
                        <Checkbox checked={this.state.provinces.indexOf("AB") > -1} />
                        <ListItemText primary={this.getProvinceName("AB")} />
                    </MenuItem>
                    <MenuItem value="BC">
                        <Checkbox checked={this.state.provinces.indexOf("BC") > -1} />
                        <ListItemText primary={this.getProvinceName("BC")} />
                    </MenuItem>
                    <MenuItem value="MB">
                        <Checkbox checked={this.state.provinces.indexOf("MB") > -1} />
                        <ListItemText primary={this.getProvinceName("MB")} />
                    </MenuItem>
                    <MenuItem value="NB">
                        <Checkbox checked={this.state.provinces.indexOf("NB") > -1} />
                        <ListItemText primary={this.getProvinceName("NB")} />
                    </MenuItem>
                    <MenuItem value="NL">
                        <Checkbox checked={this.state.provinces.indexOf("NL") > -1} />
                        <ListItemText primary={this.getProvinceName("NL")} />
                    </MenuItem>
                    <MenuItem value="NT">
                        <Checkbox checked={this.state.provinces.indexOf("NT") > -1} />
                        <ListItemText primary={this.getProvinceName("NT")} />
                    </MenuItem>
                    <MenuItem value="NS">
                        <Checkbox checked={this.state.provinces.indexOf("NS") > -1} />
                        <ListItemText primary={this.getProvinceName("NS")} />
                    </MenuItem>
                    <MenuItem value="NU">
                        <Checkbox checked={this.state.provinces.indexOf("NU") > -1} />
                        <ListItemText primary={this.getProvinceName("NU")} />
                    </MenuItem>
                    <MenuItem value="ON">
                        <Checkbox checked={this.state.provinces.indexOf("ON") > -1} />
                        <ListItemText primary={this.getProvinceName("ON")} />
                    </MenuItem>
                    <MenuItem value="PEI">
                        <Checkbox checked={this.state.provinces.indexOf("PEI") > -1} />
                        <ListItemText primary={this.getProvinceName("PEI")} />
                    </MenuItem>
                    <MenuItem value="QC">
                        <Checkbox checked={this.state.provinces.indexOf("QC") > -1} />
                        <ListItemText primary={this.getProvinceName("QC")} />
                    </MenuItem>
                    <MenuItem value="SK">
                        <Checkbox checked={this.state.provinces.indexOf("SK") > -1} />
                        <ListItemText primary={this.getProvinceName("SK")} />
                    </MenuItem>
                    <MenuItem value="YT">
                        <Checkbox checked={this.state.provinces.indexOf("YT") > -1} />
                        <ListItemText primary={this.getProvinceName("YT")} />
                    </MenuItem>
                    <MenuItem value="RT">
                        <Checkbox checked={this.state.provinces.indexOf("RT") > -1} />
                        <ListItemText primary={this.getProvinceName("RT")} />
                    </MenuItem>
                </Select>
            </FormControl>
            <FormControlLabel
                control={
                    <Checkbox checked={this.state.logarithmic}
                              onChange={() => this.setState({logarithmic: !this.state.logarithmic})}
                              color="primary"/>
                }
                label="Logarithmic Scale"
                style={{marginLeft: '24px', marginBottom: '8px'}}
            />
        </div>
    }

    renderSlicedTooltip = ({ slice }) => {
        return (
            <div style={{
                    background: 'white',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'flex-start',
                    alignItems: 'flex-start',
                    padding: '9px 12px',
                    border: '1px solid #ccc',
                }}>
                <div>Date: {slice.points[0].data.xFormatted}</div>
                {slice.points.map(point => (
                    <div
                        key={point.id}
                        style={{
                            padding: '3px 0',
                            display: 'flex',
                            justifyContent: 'flex-start',
                            alignItems: 'baseline'
                        }}>
                        <svg x={point.x} y={point.x} width="10" height="10">
                            <rect width="9" height="9"  fill={point.serieColor}/>
                        </svg>
                        <div style={{marginRight: '4px', marginLeft: '4px'}}>{this.getProvinceName(point.serieId) + ":"}</div>
                        <div >{Number(point.data.yFormatted).toLocaleString('en')}</div>
                    </div>
                ))}
            </div>
        )
    }

    render() {
        let mediaBreakPoint = this.props.dimensions[0] < 500;

        let logProperties = {
            gridYValues: [10, 100, 1000, 10000, 100000, 1000000, 10000000],
            yScale: {
                type: 'log',
                base: 10,
                max: 'auto',
            },
            axisLeft: {
                tickSize: 5,
                tickPadding: 8,
                tickRotation: 0,
                tickValues: [10, 100, 1000, 10000, 100000, 1000000, 10000000],
                legend: 'Cases - logarithmic scale (base: 10)',
                legendOffset: -48,
                legendPosition: 'middle'
            }
        }

        let linearProperties = {
            yScale:{type: 'linear', min: 'auto', max: 'auto', stacked: false, reverse: false},
            axisLeft:{
                orient: 'left',
                tickSize: 5,
                tickPadding: 8,
                tickRotation: 0,
                legend: 'Cases',
                legendOffset: -48,
                legendPosition: 'middle'
            }
        }

        let props = this.state.logarithmic ? logProperties : linearProperties;

        if(this.props.data.length > 0) {
            let provData = []
            let provinces = [];
            if(this.state.provinces.length === 0) {
                provinces = ["CA", "AB", "BC", "ON", "QC", "SK", "MB", "NS", "NB", "NL", "PEI", "YT", "NT", "NU", "RT"]
            } else {
                provinces = [...this.state.provinces]
            }
            this.props.data.forEach(e => {
                if(provinces.includes(e.id)) {
                    provData.push(e)
                }
            })
            let data = []
            if(this.state.logarithmic) {
                provData.forEach(e => {
                    let obj = {data: []}
                    obj["id"] = e.id
                    e.data.forEach(d => {
                        if(d.y !== 0) {
                            obj.data.push(d)
                        }

                    })
                    data.push(obj)
                })
            } else {
                data =[...provData]
            }
            return <div className='section'>
                <Typography variant={'h4'} align={'left'} style={{marginBottom: 8}}>Cases Curve</Typography>
                <Typography variant={'subtitle1'} align={'left'} style={{marginBottom: 8}}>Since March 1st</Typography>
                {this.renderProvinceSelect()}
                <div style={{
                    display: 'flex',
                    height: 472,
                    width: '100%',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    paddingBottom: 24
                }}>
                    <ResponsiveLine
                        {...props}
                        data={data}
                        margin={mediaBreakPoint ? {top: 50, right: 16, bottom: 50, left: 60} : {top: 50, right: 110, bottom: 50, left: 60}}
                        xScale={{
                            type: 'time',
                            format: '%Y-%m-%d',
                            precision: 'day',
                        }}
                        axisTop={null}
                        axisRight={null}
                        xFormat="time:%Y-%m-%d"
                        axisBottom={{
                            format: (d) => moment(d).tz('UTC').format('MMM DD'),
                            // tickValues: 'every 1 days',
                            orient: 'bottom',
                            tickSize: 5,
                            tickPadding: 5,
                            tickRotation: -40,
                            legend: 'Date',
                            legendOffset: 46,
                            legendPosition: 'middle'
                        }}
                        colors={{scheme: 'paired'}}
                        pointSize={2}
                        pointColor={{theme: 'background'}}
                        pointBorderWidth={2}
                        pointBorderColor={{from: 'serieColor'}}
                        pointLabel="xFormatted"
                        pointLabelYOffset={-12}
                        enableSlices={"x"}
                        sliceTooltip={this.renderSlicedTooltip}
                        legends={[
                            {
                                anchor: mediaBreakPoint ? 'left' : 'bottom-right',
                                direction: 'column',
                                justify: mediaBreakPoint,
                                translateX: mediaBreakPoint ? 12 : 100,
                                translateY: mediaBreakPoint ? 0 : 0,
                                itemsSpacing: 0,
                                itemDirection: 'left-to-right',
                                itemWidth: mediaBreakPoint ? 24 : 80,
                                itemHeight: 16,
                                itemOpacity: 0.75,
                                symbolSize: mediaBreakPoint ? 6 : 12,
                                symbolShape: 'circle',
                                symbolBorderColor: 'rgba(0, 0, 0, .5)',
                            }
                        ]}
                    />
                </div>

                {/*<div style={{display: 'flex', justifyContent: 'flex-start', marginLeft: '24px', marginBottom: '12px'}}>*/}
                    {/*<Typography variant="caption">*/}
                        {/*<Link href="https://www.canada.ca/en/public-health/services/diseases/2019-novel-coronavirus-infection/health-professionals/epidemiological-summary-covid-19-cases.html"*/}
                              {/*target="_blank"*/}
                              {/*rel="noreferrer">*/}
                            {/*Source*/}
                        {/*</Link>*/}
                    {/*</Typography>*/}
                {/*</div>*/}
            </div>
        } else {
            return <div/>
        }
    }
}

export default CurveChart